import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent implements OnInit {
  @Input()
  isLoading!: boolean;
  @Input()
  message: string = 'Loading...';

  public showOverlay = false;

  private delayTimer: any;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isLoading']) {
      if (this.isLoading) {
        // start a 300ms timer before showing
        this.delayTimer = setTimeout(() => {
          this.showOverlay = true;
        }, 300);
      } else {
        clearTimeout(this.delayTimer);
        this.showOverlay = false;
      }
    }
  }

  ngOnDestroy() {
    clearTimeout(this.delayTimer);
  }

  ngOnInit(): void {}
}
